// Third Party
import { catchError, map, mergeMap } from "rxjs/operators";
import { from, of } from "rxjs";
import { ofType } from "redux-observable";

// Project
import { messageAttachmentOpenFailed, messageAttachmentOpenSucceeded } from "../../../../actions/messageViewActions";
import { MESSAGE_ATTACHMENT_OPEN_START } from "../../../../constants/ActionTypes";

// Third parameter of epic is the "dependencies" property on the epic options passed to createEpicMiddleware()
const messageAttachmentOpenStartEpic = (action$, state$, { io, messagingClient }) => action$.pipe(
  ofType(MESSAGE_ATTACHMENT_OPEN_START),
  mergeMap(action => from(
    messagingClient.getMailboxMessageAttachment(action.mailboxAddress, action.messageIdentity,
      action.attachmentIdentifier)
      .then(io.openResponse))
    .pipe(
      map(() => messageAttachmentOpenSucceeded(action.mailboxAddress, action.messageIdentity,
        action.attachmentIdentifier)),
      catchError(error => of(messageAttachmentOpenFailed(action.mailboxAddress, action.messageIdentity, error)))
    )
  )
);

export default messageAttachmentOpenStartEpic;
